// extracted by mini-css-extract-plugin
export default {"load":"loading_load__ImfiJ","img":"loading_img__3yxHb","rotation":"loading_rotation__DRJqd"};